"use strict";

import Utils from './Utils';

export default class Price {
	/**
	 * Clean any price formatting
	 * @param {Number|String} price
	 * @param {Boolean} isInDebugMode
	 * @return {Number}
	 */
	static cleanPrice(price, isInDebugMode = false) {
		if (typeof price === "number") {
			const _priceCents = Math.ceil(price * 100);
			Utils.debug(isInDebugMode, "Cleaning price from number '%s', cleaned price is '%s'", price, _priceCents);
			return _priceCents;
		}

		if (typeof price === "string") {
			let _priceCentsStr = "";

			// find prices between 1.000 and 999.9999,99
			let matches = price.match(/(\d{1,3}(\ |\.|\,)?\d{3})((\.|\,)(\d{1,2}))?/);		// idx 0 = full match, idx 1 = int amount, idx 5 = digits
			if (matches) {
				_priceCentsStr = matches[1].replace(/[ ,.]/g, '');
				if (matches.length > 5 && matches[5]) {
					_priceCentsStr += "." + matches[5];
				}
			} else {
				// find prices between 100 and 999,99
				matches = price.match(/(\d{3})((\.|\,)(\d{1,2}))?/);			// idx 0 = full match, idx 1 = int amount, idx 4 = digits
				if (matches) {
					_priceCentsStr = matches[1].replace(/[ ,.]/g, '');
					if (matches.length > 4 && matches[4]) {
						_priceCentsStr += "." + matches[4];
					}
				} else {
					// find prices between 0 and 99,99
					matches = price.match(/(\d{1,2})((\.|\,)(\d{1,2}))?/);			// idx 0 = full match, idx 1 = int amount, idx 4 = digits
					if (matches) {
						_priceCentsStr = matches[1].replace(/[ ,.]/g, '');
						if (matches.length > 4 && matches[4]) {
							_priceCentsStr += "." + matches[4];
						}
					}
				}
			}

			if (_priceCentsStr) {
				const _priceCents = Math.ceil(Number(_priceCentsStr) * 100);
				Utils.debug(isInDebugMode, "Cleaning price from string '%s', cleaned price is '%s'", price.length < 100 ? price : price.substring(0, 90) + '...', _priceCents);
				return _priceCents;
			}
		}

		Utils.debug(isInDebugMode, "Cleaning price from '%s', cleaned price is '%s'", price, 0);
		return 0;
	}

}